import Vue from 'vue';

// Domain
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';
import {
  CreateEmergencyFundInvestorGoalStateManager,
} from '@/modules/flagship/emergency-fund-investor-goal/domain/state/create-emergency-fund-investor-goal-state-manager';
import CreateEmergencyFundInvestorGoalState
  from '@/modules/flagship/emergency-fund-investor-goal/domain/state/create-emergency-fund-investor-goal-state';

@Injectable()
class CreateEmergencyFundInvestorGoalVueStateManager
implements CreateEmergencyFundInvestorGoalStateManager {
  private _state: CreateEmergencyFundInvestorGoalState = Vue.observable<
    CreateEmergencyFundInvestorGoalState
  >(
    new CreateEmergencyFundInvestorGoalState(),
  );

  private readonly observers: Observer[] = [];

  get state(): CreateEmergencyFundInvestorGoalState {
    return this._state;
  }

  set state(value: CreateEmergencyFundInvestorGoalState) {
    this._state = value;
  }

  patch(state: Partial<CreateEmergencyFundInvestorGoalState>) {
    type Keys = keyof CreateEmergencyFundInvestorGoalState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}

export default CreateEmergencyFundInvestorGoalVueStateManager;
